<section [formGroup]="group" class="section" *ngIf="group">
  <header class="section-header">
    <h4>Customer</h4>
    <span class="hint">{{ requirementLabel }}</span>
  </header>

  <div class="mode-toggle">
    <app-trigger-mode-radio-group
      formControlName="mode"
      [options]="modeOptions"
    ></app-trigger-mode-radio-group>
  </div>

  <div class="fields" *ngIf="mode === 'clone_existing'">
    <div class="field user-search">
      <label>Search by name or email</label>
      <div class="user-search-input">
        <mat-form-field appearance="outline">
          <input
            matInput
            [value]="userSearchTerm"
            (input)="searchInput.emit($any($event.target).value)"
            placeholder="Type at least 2 characters..."
            [disabled]="!!selectedUser"
          />
        </mat-form-field>
        <button
          *ngIf="selectedUser"
          mat-button
          type="button"
          (click)="userCleared.emit()"
        >
          Change
        </button>
      </div>

      <div class="user-search-status" *ngIf="userSearchLoading">Searching...</div>

      <ul
        class="user-search-results"
        *ngIf="!selectedUser && userSearchResults.length > 0"
      >
        <li *ngFor="let u of userSearchResults" (click)="userPicked.emit(u)">
          {{ u.label }}
        </li>
      </ul>

      <p class="hint" *ngIf="selectedUser">
        {{ selectedHint }}
      </p>
    </div>
  </div>

  <p class="hint" *ngIf="mode === 'generate'">
    {{ generateHint }}
  </p>

  <p class="hint" *ngIf="mode === 'clone_existing' && !selectedUser">
    {{ cloneHint }}
  </p>

  <p class="hint" *ngIf="mode === 'none'">
    {{ noneHint }}
  </p>
</section>
